import defaultAvatarImg from '../Logo/default-avatar.png';

/** Bundled default avatar: src/Logo/default-avatar.png */
export const DEFAULT_AVATAR = defaultAvatarImg;

/** Fallback src for missing or broken profile pictures */
export function defaultAvatarUrl() {
  return DEFAULT_AVATAR;
}

/** Attach to <img onError={handleAvatarError} /> when the URL may 404 */
export function handleAvatarError(e) {
  if (e?.target) {
    e.target.onerror = null;
    e.target.src = DEFAULT_AVATAR;
  }
}

export function resolveProfilePicUrl(pic, apiBaseUrl) {
  if (pic == null || typeof pic !== 'string') {
    return '';
  }
  const trimmed = pic.trim();
  if (!trimmed) {
    return '';
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  const base = String(apiBaseUrl || '').replace(/\/+$/, '');
  const path = trimmed.replace(/^\/+/, '');
  if (path.startsWith('uploads/')) {
    return `${base}/${path}`;
  }
  return `${base}/uploads/${path}`;
}

/** Prefer API profile_picture, then profile_pic; always returns a usable src. */
export function resolveAvatarUrl(entity, apiBaseUrl) {
  const pic =
    entity?.profile_picture ??
    entity?.profile_pic ??
    '';
  const resolved = resolveProfilePicUrl(pic, apiBaseUrl);
  return resolved || DEFAULT_AVATAR;
}
